import { useNavigate } from 'react-router-dom';
import { Button } from '@heroui/react';
import { ArrowLeft2 } from 'iconsax-react';

export const Terms = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={`flex h-[50px] gap-x-4
          bg-white fixed top-0 left-0 right-0 z-10 border-b px-4
            items-center -ml-4`}
      >
        <Button isIconOnly variant="light" onPress={() => navigate(-1)}>
          <ArrowLeft2 size="24" color="#222222" />
        </Button>

        <p className="text-[#222223] font-medium">Правила пользования</p>
      </div>
      <div className="w-full h-[50px]" />

      <div className="h-[calc(100vh-50px)] p-4 overflow-y-scroll">
        <p>Правила пользования</p>
        <br />
        <p>
          Если по какой-либо причине Вы не согласны с условиями настоящего
          Пользовательского соглашения (Публичной Оферты на заключение договора
          оказания информационно-консультационных услуг) конфиденциальность и
          защита персональной информации, Политикой Конфиденциальности, не
          используйте сайт https://zerde24.kz/ и не регистрируйтесь.
        </p>
        <br />
        <h2>
          ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ (ПУБЛИЧНАЯ ОФЕРТА НА ЗАКЛЮЧЕНИЕ ДОГОВОРА),
          ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ И ЗАЩИТA ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ
        </h2>
        <br />
        <br />
        <p>
          Настоящий документ, постоянно размещенный в сети Интернет по сетевому
          адресу: https://zerde24.kz/ согласно статьям 389, 395 и 396
          Гражданского кодекса Республики Казахстан (далее по тексту – «ГК РК»),
          является Пользовательским соглашением и официальным предложением
          (публичной офертой) "zerde24", БИН/ИИН 240340027338, (далее –
          Компания), в лице директора Амалбеков Медет Ерланұлы, действующего на
          основании Устава, предлагает заключить Договор (далее по тексту
          «Оферта» и/или «Договор») к любому заинтересованному лицу физическому
          лицу старше 18 (восемнадцати) лет, которое использует сайт в сети
          Интернет https://zerde24.kz/ (далее - Сайт) и примет настоящее
          предложение на указанных ниже условиях, именуемый в дальнейшем
          «Клиент», а в совместном упоминании в дальнейшем именуемые «Стороны».
        </p>
        <br />
        <p>
          Договор регламентируется нормами гражданского законодательства, в том
          числе, но не исключительно нормами о договоре присоединения (статья
          389 ГК РК) – поскольку его условия определены Копанией в настоящей
          Оферте и могут быть приняты любым заинтересованным физическим лицом,
          достигшим 18 (восемнадцати) лет не иначе как путем присоединения к
          предложенному Договору в целом без каких-либо изъятий и ограничений.
          Настоящая Оферта вступает в силу с момента размещения в сети Интернет
          по адресу: https://zerde24.kz/. Компания вправе в любое время по
          своему усмотрению изменить условия Оферты или отозвать ее в порядке,
          предусмотренном настоящим Договором.
        </p>
        <br />
        <p>
          В случае изменения Компанией условий Оферты, изменения вступают в силу
          с момента публикации измененных условий Оферты в сети Интернет по
          адресу: https://zerde24.kz/, если иной срок не указан Компанией в
          соответствующем уведомлении об изменениях. В соответствии статьям 395
          ГК РК и 396 ГК РК акцепт Оферты равносилен заключению Договора на
          условиях, изложенных в настоящей Оферте. Клиент считается заключившим
          с Компанией Договор о _______________________ посредством полного и
          безоговорочного принятия условий настоящей Оферты (Далее – «Акцепт»)
          путем совершения в совокупности следующих действий: − Ознакомления с
          условиями настоящего Договора, устанавливающего условия использования
          Сайта, путем нажатия кнопки «Я принимаю условия пользовательского
          соглашения и даю согласие на обработку моих персональных данных», либо
          кнопки “сделать Заказ”, либо кнопки “оплатить”, “зарегистрироваться,
          “принять участие” или “регистрация” при оформлении Заказа и
          регистрации Оплаты на Сайте; − Выражение Клиентом согласия с условиями
          Оферты путем внесения оплаты в порядке, определенном в Договоре;
        </p>
        <br />
        <p>
          Договор считается заключенным с момента совершения Клиентом
          определенных Офертой действий подразумевающих под собойАкцепт.
        </p>
        <br />
        <p>
          <strong>
            1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ Конфиденциальная информация – информация,
            которая включает в себя данные об аппаратной части и программном
            обеспечении, экранах, технических характеристиках, дизайнах, планах,
            чертежах, данных, прототипах, открытиях, исследованиях, разработках,
            методах, процессах, процедурах, курсах, мастер-классах и вебинарах,
            улучшениях, «ноу-хау», конфигурациях, маркетинговых техниках, а
            также о планах, техническую и коммерческую информацию, материалы в
            устной, демонстрационной, письменной, графической или машиночитаемой
            форме, которая не была опубликована, и не является доступной для
            широкой общественности и (или) торговли, и которая поддерживается в
            качестве конфиденциальной и служебной информации для раскрывающей
            стороны.
          </strong>
        </p>
        <br />
        <p>
          Сайт - представляет собой программно-аппаратный комплекс Компании,
          размещенный в интернете по адресу: https://zerde24.kz/, содержащий
          совокупность информации, текстов, графических элементов, дизайна,
          изображений, фото и видеоматериалов (аудиовизуальных произведений) и
          иных объектов интеллектуальной собственности, а также программ для
          ЭВМ, содержащихся в информационной системе, обеспечивающей доступность
          такой информации в сети Интернет, товарный знак и пр., которые
          принадлежат Компании в полном объеме. Использование Клиентом Сайта,
          его содержимого и составляющих (как в целом, так и фрагментарно) и
          прочих разработанных Компанией программных решений не означает
          передачи (отчуждения) Клиенту и (или) любому третьему лицу прав на
          результаты интеллектуальной деятельности, как в целом, так и в части.
          Заказ — должным образом оформленный и сформированный посредством Сайта
          или Мобильного приложения запрос Клиента на получение услуг, выбранных
          Клиентом на Сайте или в Мобильном приложении, подразумевающий под
          собой уточнение видов Услуг Компаний, стоимости, сроков и условий
          оказания Услуг Компанией.
        </p>
        <br />
        <h2>2. ПРЕДМЕТ ДОГОВОРА</h2>
        <p>
          <strong>
            2.1. Компания оказывает Услуги по канцелярских товаров (Далее –
            «Услуги») Клиенту, в соответствии с условиями, опубликованными на
            Сайте, а Клиент оплачивает и принимает Услуги Компании на условиях
            настоящего Договора.
          </strong>
        </p>
        <p>
          <strong>
            2.2. Подробное описание Услуг размещено Компанией на Сайте.
          </strong>
        </p>
        <br />
        <h2>
          3. СТОИМОСТЬ, ПОРЯДОК ОПЛАТЫ И ОКАЗАНИЯ УСЛУГ, ВОЗВРАТ СТОИМОСТИ УСЛУГ
        </h2>
        <p>
          <strong>
            3.1. Услуги оказываются согласно выбранным Клиентом при
            осуществлении Заказа на Сайте условиям оказания Услуг.
          </strong>
        </p>
        <p>
          <strong>
            3.2. Заказ оформляется на Сайте, или через представителя Компании по
            телефону, или в офисе Компании, и содержит указание на вид Услуг,
            место оказания Услуг и данные Клиента (ФИО Клиента, его телефон и
            прочая необходимая информация).
          </strong>
        </p>
        <p>
          <strong>
            3.3. Если Клиент в течение 2 (Двух) рабочих дней после оказания
            Услуг не предъявит Компании претензии с указанием недостатков
            оказанных Услуг, Услуги считаются оказанными Компанией своевременно,
            надлежащим образом, в полном объеме и принятыми Клиентом без
            возражений и замечаний.
          </strong>
        </p>
        <p>
          <strong>
            3.4. Оплата стоимости Услуг, указанной в п. 2.1 Оферты,
            осуществляется Клиентом безналичным способом на условиях, выбранных
            Клиентом при осуществлении Клиентом Заказа (выбора и последующей
            оплаты) Услуг.
          </strong>
        </p>
        <p>
          <strong>
            3.5. Клиент производит оплату Компании (при наличии) путем
            безналичной оплаты на Сайте, или любым другим способом, который
            Компания использует и принимает на любых
            сайтах/платформах/приложениях, где Компания осуществляет свою
            деятельность.
          </strong>
        </p>
        <p>
          <strong>
            3.6. Оплата Услуг осуществляется в тенге, НДС не облагается.
          </strong>
        </p>
        <p>
          <strong>
            3.6. Услуга считается оплаченной с даты поступления денежных средств
            на счет Компании, и подтверждается обязательным предъявлением
            Клиентом Компании документа об оплате Услуг.
          </strong>
        </p>
        <p>
          <strong>
            3.8. Компания не несет ответственности за данные и конфиденциальную
            информацию, предоставляемые Клиентом третьим лицам.
          </strong>
        </p>
        <p>
          <strong>
            3.9. Компания не несет ответственности за успешность процесса оплаты
            за Услугу, которую осуществляет Клиент через инфраструктуру третьих
            лиц (Банков, Платежных Систем, Платежных Организаций и т.д.).
          </strong>
        </p>
        <p>
          <strong>
            3.10. Возврат стоимости Услуг осуществляется Исполнителем Клиенту в
            случаях, предусмотренных законодательством Республики Казахстан. В
            случае оплаты Услуг Клиентом с помощью инфраструктуры третьих лиц
            (Платежных Систем, Банков, Платежных Организаций и т.д.), данные
            третьи лица не несут ответственности за осуществления возвратов по
            Услугам, оказанных Компанией в рамках данного Договора.
          </strong>
        </p>
        <br />
        <h2>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
        <p>
          <strong>4.1. Компания обязана:</strong>
        </p>
        <p>
          <strong>
            4.1.1. Оказать Услугу надлежащего качества в соответствии с
            Условиями настоящего Договора.
          </strong>
        </p>
        <p>
          <strong>
            4.1.2. Предоставить Услугу в помещении и с оснащением, которые
            соответствуют санитарным, гигиеническим, противопожарным
            требованиям.
          </strong>
        </p>
        <p>
          <strong>
            4.1.3. По письменному требованию Клиента, в случае расторжения
            данного Договора, возместить ему сумму оплаты Услуг за вычетом из
            уплаченной Клиентом суммы стоимости объема уже полученной Услуги,
            подтвержденных документально.
          </strong>
        </p>
        <p>
          <strong>4.2. Компания имеет право:</strong>
        </p>
        <p>
          <strong>
            4.2.1. Самостоятельно выбирать методы и способы оказания Услуг, в
            том числе, но не ограничиваясь, вносить изменения в условия оказания
            Услуг в случае необходимости таких изменений.
          </strong>
        </p>
        <p>
          <strong>
            4.2.2.Давать рекомендации/консультации Клиенту относительно
            оказываемой Услуги.
          </strong>
        </p>
        <p>
          <strong>
            4.2.3. Привлекать к оказанию услуг третьих лиц без получения
            согласия Клиента, оставаясь ответственным за их действия перед
            Клиентом.
          </strong>
        </p>
        <p>
          <strong>
            4.2.4. Не оказывать Услугу Клиенту, не оплатившему стоимость Услуги
            или не оплатившему в полном объеме стоимостьУслуги в порядке и
            сроки, предусмотренные данным Договором.
          </strong>
        </p>
        <p>
          <strong>
            4.2.5. Отказаться от оказания Услуг на условиях, предусмотренных
            настоящим Договором Оферты.
          </strong>
        </p>
        <p>
          <strong>4.3. Клиент обязан:</strong>
        </p>
        <p>
          <strong>
            4.3.1. Своевременно информировать Компанию обо всех обстоятельствах,
            относящихся к предмету Договора, предоставлять достоверную
            информацию о себе и/или Участнике, имеющую значение для оказания
            Компанией Услуг, нести ответственность за нарушение гарантий,
            изложенных в разделе 7 данного Договора оферты.
          </strong>
        </p>
        <p>
          <strong>
            4.3.2. Оплатить стоимость Услуги в порядке, размере и сроки,
            предусмотренные настоящей Договором.
          </strong>
        </p>
        <p>
          <strong>4.4. Клиент имеет право:</strong>
        </p>
        <p>
          <strong>
            4.4.1. Требовать надлежащего оказания Компанией Услуг,
            предусмотренных данным Договором.
          </strong>
        </p>
        <p>
          <strong>
            4.4.2. Получать полную и достоверную информацию по вопросам оказания
            Услуги.
          </strong>
        </p>
        <p>
          <strong>
            4.4.3. Отказаться от данного Договора (односторонний внесудебный
            отказ от исполнения) полностью или частично на условиях,
            предусмотренных данным Договором оферты.
          </strong>
        </p>
        <br />
        <h2>
          5. СРОК ДЕЙСТВИЯ ОФЕРТЫ. СРОК ДЕЙСТВИЯ ДОГОВОРА И ПОРЯДОК ЕГО
          РАСТОРЖЕНИЯ
        </h2>
        <p>
          <strong>
            5.1. Настоящая Оферта вступает в силу с момента её публикации на
            Сайте и действует до момента её отзыва Компанией.
          </strong>
        </p>
        <p>
          <strong>
            5.5. Договор оферты может быть расторгнут по соглашению Сторон.
          </strong>
        </p>
        <p>
          <strong>
            5.6. Договор оферты может быть расторгнут в одностороннем
            внесудебном порядке по инициативе Клиента (полностью или частично) в
            случае, если он отказывается от получения Услуги. В этом случае,
            Клиент должен письменно уведомить Компанию об отказе от Исполнения
            не позднее чем за 15 (пятнадцать) рабочих дней до желаемой даты
            расторжения Договора.
          </strong>
        </p>
        <p>
          <strong>
            5.7. Настоящий Договор оферты может быть расторгнут в одностороннем
            внесудебном порядке по инициативе Компании (полностью или частично)
            при условии письменного уведомления Клиента об отказе от исполнения
            не позднее чем за 15 (пятнадцать) рабочих дней до желаемой даты
            расторжения Договора, а в следующих случаях - с момента уведомления
            Компанией Клиента:
          </strong>
        </p>
        <p>
          <strong>
            5.7.1. Несоблюдение Клиентом обязанностей, предусмотренных в пункте
            4.3, включая, но не ограничиваясь случаем невнесения Клиентом
            полного платежа за оказание Услуг в установленный срок.
          </strong>
        </p>
        <br />
        <h2>6. ОТВЕТСТВЕННОСТЬ. РАЗРЕШЕНИЕ СПОРОВ</h2>
        <p>
          <strong>
            6.1.В случае неисполнения или ненадлежащего исполнения обязательств
            по Договору Стороны несут ответственность в соответствии с
            действующим законодательством Республики Казахстан.
          </strong>
        </p>
        <p>
          <strong>
            6.2. Стороны освобождаются от ответственности за частичное или
            полное неисполнение обязательств по Договору в случае, если оно
            явилось следствием действия чрезвычайных и непредотвратимых
            обстоятельств, подтвержденных в установленном законодательством
            порядке, препятствующих надлежащему исполнению обязательств по
            Договору.
          </strong>
        </p>
        <p>
          <strong>
            6.3. Все споры и разногласия, возникающие в связи с оказанием Услуг,
            подлежат урегулированию путем переговоров. Претензионный порядок
            является для Сторон обязательным. Срок рассмотрения Претензии
            Составляет 10 (Десять) календарных дней.
          </strong>
        </p>
        <p>
          <strong>
            6.4. В случае неурегулирования разногласий путем досудебного
            претензионного порядка Стороны имеют право обратиться в суд по месту
            нахождения Компании в соответствии с законодательством Республики
            Казахстан.
          </strong>
        </p>
        <br />
        <h2>7. ПРОЧИЕ УСЛОВИЯ</h2>
        <p>
          <strong>
            7.1. Клиент гарантирует, что отсутствуют какие-либо обстоятельства,
            препятствующие получению Услуг по настоящему Договору оферты.
          </strong>
        </p>
        <p>
          <strong>
            7.2. При изменении юридического статуса, адреса, банковских
            реквизитов, данных, Сторона, у которой произошли такие изменения,
            обязана уведомить другую Сторону в течение 5 (пяти) рабочих дней с
            даты такого изменения по электронной почте или по другим доступным
            сторонам каналам связи. До получения такого уведомления все
            операции, сделанные по прежним реквизитам, считаются надлежаще
            выполненными.
          </strong>
        </p>
        <p>
          <strong>
            7.3.В случае если одно или более положений настоящей Оферты являются
            по какой-либо причине недействительными, не имеющими юридической
            силы, такая недействительность не оказывает влияния на
            действительность любого другого положения Оферты (Договора), которые
            остаются в силе.
          </strong>
        </p>
        <p>
          <strong>
            7.4. Не вступая в противоречие с условиями настоящей Оферты, Клиент
            и Компания вправе в любое время оформить Договор на оказание услуг в
            форме письменного двухстороннего документа, скрепленного печатями и
            подписями Сторон.
          </strong>
        </p>
        <p>
          <strong>
            7.5. В течение срока действия настоящего Договора, а также по
            истечении срока его действия Стороны обязуются не разглашать и не
            использовать в своих интересах, равно как и в интересах любых
            третьих лиц, любую конфиденциальную информацию, в том числе деловую,
            коммерческую, техническую и иную информацию, которая не может быть
            известна Сторонам из общедоступных источников, переданную одной
            Стороной другой Стороне и которая стала известной Сторонам в связи с
            заключением и исполнением настоящего Договора.
          </strong>
        </p>
        <p>
          <strong>
            7.6. Клиент подтверждает, что с настоящей Офертой ознакомлен и
            согласен с ее положениями.
          </strong>
        </p>
        <p>
          <strong>
            7.7. Стороны признают юридически значимой переписку, направляемую по
            адресам электронной почты, указанным Клиентом в Заказе, и Компанией
            - в настоящей Оферте.
          </strong>
        </p>
        <br />
      </div>
    </>
  );
};
